import api from '../../api/restaurant/restaurantRawMaterialApi';
import ProductUnitService from '../ProductUnitService';
import SupplierService from '../supplier/SupplierService';
import {
  CustomResponse,
  RawMaterialSupplierOption,
  RawMaterialUnitOption,
  RestaurantRawMaterialDTO,
  RestaurantRawMaterialFilters,
  RestaurantRawMaterialForm,
  RestaurantRawMaterialPage,
} from '../../types/restaurant/RestaurantRawMaterialTypes';
import { RestaurantPageRequest } from '../../types/restaurant/RestaurantRecipeTypes';
import { restaurantPageQuery } from './restaurantPageQuery';
const payload = (f: RestaurantRawMaterialForm) => ({
  categoryId: Number(f.categoryId),
  unitId: Number(f.unitId),
  supplierId: f.supplierId === '' ? null : Number(f.supplierId),
  code: f.code.trim().toUpperCase(),
  name: f.name.trim(),
  description: f.description.trim() || null,
  minimumStock: f.minimumStock === '' ? null : Number(f.minimumStock),
  currentStock: f.currentStock === '' ? null : Number(f.currentStock),
  cost: f.cost === '' ? null : Number(f.cost),
  barcode: f.barcode.trim() || null,
  ...(f.id ? { active: f.active } : {}),
});
const RestaurantRawMaterialService = {
  listFiltered: async (
    branchId: number,
    request: RestaurantPageRequest<RestaurantRawMaterialFilters>
  ) => {
    const query = restaurantPageQuery(request.page, request.size, request.sort);
    const f = request.filters;
    return (
      await api.addCustom(`/branches/${branchId}/filtered?${query}`, {
        search: f.search?.trim() || null,
        categoryId: f.categoryId,
        unitId: f.unitId,
        supplierId: f.supplierId,
        active: f.active,
      })
    ).data as RestaurantRawMaterialPage;
  },
  list: async (branchId: number, activeOnly = false) =>
    (await api.fetchCustom(`/branches/${branchId}?activeOnly=${activeOnly}`))
      .data as CustomResponse<RestaurantRawMaterialDTO[]>,
  listByCategory: async (
    branchId: number,
    categoryId: number,
    activeOnly = false
  ) =>
    (
      await api.fetchCustom(
        `/branches/${branchId}/categories/${categoryId}?activeOnly=${activeOnly}`
      )
    ).data as CustomResponse<RestaurantRawMaterialDTO[]>,
  get: async (id: number) =>
    (await api.fetchById(id)).data as CustomResponse<RestaurantRawMaterialDTO>,
  create: async (branchId: number, f: RestaurantRawMaterialForm) =>
    (await api.addCustom(`/branches/${branchId}`, payload(f)))
      .data as CustomResponse<RestaurantRawMaterialDTO>,
  update: async (id: number, f: RestaurantRawMaterialForm) =>
    (await api.modify(id, payload(f)))
      .data as CustomResponse<RestaurantRawMaterialDTO>,
  updateActive: async (id: number, active: boolean) =>
    (await api.patchCustom(`${id}/active`, { active }))
      .data as CustomResponse<RestaurantRawMaterialDTO>,
  units: async () =>
    (await ProductUnitService.getDropdown()) as RawMaterialUnitOption[],
  suppliers: async () => {
    const r = await SupplierService.getDropdown();
    return (r.data ?? []) as RawMaterialSupplierOption[];
  },
};
export default RestaurantRawMaterialService;
